import { useCallback } from 'react';
import { useGetUserFirstNameWithFallback } from './useGetUserFirstNameWithFallback';
import { useGetUserLastNameWithFallback } from './useGetUserLastNameWithFallback';

type P = {
  firstName?: null | string;
  lastName?: null | string;
  middleName?: null | string;
};

export const useGetUserFullNameWithFallback = () => {
  const getFirstNameWithFallback = useGetUserFirstNameWithFallback();
  const getLastNameWithFallback = useGetUserLastNameWithFallback();

  return useCallback(
    ({ firstName, lastName, middleName }: P) =>
      [getFirstNameWithFallback({ firstName, lastName }), middleName, getLastNameWithFallback({ firstName, lastName })]
        .filter(Boolean)
        .join(' ')
        .trim(),
    [getFirstNameWithFallback, getLastNameWithFallback],
  );
};
